import AdvancedController from "./advanced-controller"
import { gsap } from 'gsap'

export default class ContactPersonController extends AdvancedController {

  static targets = [
    'form',
    "contactButton"
  ];


  static values = {
    email: String,
    isVisible: {
      type: Boolean,
      default: false
    }
  }

  connect() {
    const emailInput = this.element.querySelector('#field_contact_email')
    if (!emailInput) {
      console.warn("Contact Person: No email input found")
      return
    }
    emailInput.value = this.emailValue

    this.element.querySelector('.frm_start_over').addEventListener('click', (e) => {
      this.onContactButtonClick(e);
    })
  }

  onContactButtonClick(e) {

    e.preventDefault();

    if (!this.isVisibleValue) {
      this.slideIn(this.formTarget)
      this.slideOut(this.contactButtonTarget)
    } else {
      this.slideOut(this.formTarget)
      this.slideIn(this.contactButtonTarget)

    }
    this.isVisibleValue = !this.isVisibleValue
  }

  slideIn(target) {
    if (target === this.contactButtonTarget) {
      gsap.
        fromTo(target, { visibility: 'visible', display: 'flex', height: '0px' }, { height: 'auto' })
    } else {
      gsap.
        fromTo(target, { visibility: 'visible', display: 'block', height: '0px' }, { height: 'auto' })
    }
  }

  slideOut(target) {
    gsap.
      fromTo(target, { height: `${target.offsetHeight}px` }, {
        height: '0px', onComplete: () => {
          target.style.visibility = 'hidden'
        }
      })
  }

}